import { Hidden } from '@/components/Atoms/Hidden/Hidden';
import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import { HeadTitle } from '@/components/Molecules/HeadMeta/HeadMeta';
import { NavTabs } from '@/components/Molecules/NavTabs/NavTabs';
import navTabsStyles from '@/components/Molecules/NavTabs/NavTabs.module.css';
import { Stack } from '@/components/Molecules/Stack/Stack';
import { PageHeader } from '@/components/Organisms/PageHeader/PageHeader';
import useTranslation from '@/hooks/useTranslation';
import Link from 'next/link';
import type { FCh } from 'react-fc';
import styled from 'styled-components';

interface IProps {
    active: 'events' | 'ondemand';
    title: string;
}

export const EventsListTemplate: FCh<IProps> = ({ active, title, children }) => {
    const { t } = useTranslation('events');
    return (
        <>
            <HeadTitle title={`${title} | ${t('common:SiteSection.events')}`} />
            <PageHeader breadCrumbs={[]} title={t('common:SiteSection.events')} headingElement="span" />
            <Hidden as="h1">{title}</Hidden>
            <CenteredPageContent>
                <StyledNavTabs>
                    <li>
                        <Link href="/events" className={navTabsStyles.navTabsLink} aria-selected={active === 'events'}>
                            {t('ListTemplate.upcoming_heading')}
                        </Link>
                    </li>
                    <li>
                        <Link
                            href="/events/past"
                            className={navTabsStyles.navTabsLink}
                            aria-selected={active === 'ondemand'}
                        >
                            {t('ListTemplate.past_heading')}
                        </Link>
                    </li>
                </StyledNavTabs>
            </CenteredPageContent>
            <Stack>{children}</Stack>
        </>
    );
};

const StyledNavTabs = styled(NavTabs)`
    margin-bottom: 60px;
`;
